// extracted by mini-css-extract-plugin
export var cardHeader = "_sf-0";
export var reorderHandle = "_sf-3";
export var titleArea = "_sf-1";
export var titleAreaWithHandle = "_sf-2";